import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/changeRequests';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const createChangeRequest = (changeData, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.ChangeRequest.crud(), changeData)
        .then((response) => {
            dispatch({
                type: Types.CREATE_CHANGE_REQUEST,
                payload: response.data
            });
            callback(true);
        })
        .catch((err) => {
            toast.error(`Erro: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 });
            callback();
        })
    }
}

export const getChangeRequest = (id) => {
    return (dispatch) => {
        dispatch({
            type: Types.GET_CHANGE_REQUEST,
            payload: null,
        });
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.ChangeRequest.crud(`/${id}`))
        .then((response) => {
            dispatch({
                type: Types.GET_CHANGE_REQUEST,
                payload: response.data
            })
        })
        .catch((err) => {
            console.log(err)
            toast.error(`Erro ao buscar pelo pedido de acesso: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 });
            dispatch({
                type: Types.GET_CHANGE_REQUEST,
                payload: null,
            });
        })
    }
}

export const getAllChangeRequests = (page, limit, query, sort="") => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.ChangeRequest.crud('', {page, limit, query, sort}))
        .then((response) => {
            dispatch({
                type: Types.GET_CHANGE_REQUESTS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_CHANGE_REQUESTS,
                payload: []
            });
        })
    }
}

export const getAllChangeRequestsFromUser = (username, page="", limit="", query="", sort="") => {
  if (!username) {
    return () => {}
  }
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.ChangeRequest.crudUsername(`/${username}`, {page, limit, query, sort}))
        .then((response) => {
            dispatch({
                type: Types.GET_CHANGE_REQUESTS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_CHANGE_REQUESTS,
                payload: []
            });
        })
    }
}

export const giveChangeRequest = (changeRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.ChangeRequest.giveChange(`/${changeRequestId}`, query), body)
        .then((response) => {
            dispatch({
                type: Types.GIVE_CHANGE_REQUEST,
                payload: response.data
            })
            toast.success('Mudança realizada com sucesso!', { autoClose: 10000 })
            callback();
        })
        .catch((err) => {
            toast.error(`Erro durante a aplicação da mudança: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 })
            dispatch({
                type: Types.GIVE_CHANGE_REQUEST,
            })
        })
    }
}

export const denyChangeRequest = (changeRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.ChangeRequest.denyChange(`/${changeRequestId}`, query), body)
        .then((response) => {
            dispatch({
                type: Types.DENY_CHANGE_REQUEST,
                payload: response.data
            })
            toast.success('Pedido negado com sucesso!', { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            console.log(err)
            toast.error(`Erro durante negação do pedido: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 });
            dispatch({
                type: Types.DENY_CHANGE_REQUEST,
                payload: []
            })
        })
    }
}

export const removeChangeRequest = (changeRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.ChangeRequest.removeChange(`/${changeRequestId}`, query), body)
        .then((response) => {
            dispatch({
                type: Types.REMOVE_CHANGE_REQUEST,
                payload: response.data
            });
            toast.success('Pedido removido com sucesso!', { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            console.log(err)
            toast.error(`Erro durante remoção do pedido: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 })
            dispatch({
                type: Types.REMOVE_CHANGE_REQUEST,
                payload: [],
            })
        })
    }
}
